import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy,Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { BehaviorSubject } from 'rxjs';

import { FulfillerService } from './fulfiller.service';

export interface AddStoreFulfillerDialogResult {
    fulfillerId: string;
}

export interface AddStoreFulfillerDialogData {
    usedFulfillerId: string[];
}

@Component({
    selector: 'admin-add-store-fulfiller-dialog',
    templateUrl: './add-store-fulfiller-dialog.component.html',
    styleUrls: ['./add-store-fulfiller-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, MatDialogActions, MatButton, MatDialogClose, AsyncPipe],
})
export class AddStoreFulfillerDialogComponent implements OnInit {
    private readonly dialogRef = inject<MatDialogRef<AddStoreFulfillerDialogComponent, AddStoreFulfillerDialogResult>>(MatDialogRef);
    private readonly fulfillerService = inject(FulfillerService);
    readonly data = inject<AddStoreFulfillerDialogData>(MAT_DIALOG_DATA);

    fulfillerId?: string;
    fulfillerIds: string[] = [];
    @ViewChild('form')
    form: NgForm;

    filteredFulfillerIds = new BehaviorSubject<string[]>([]);

    ngOnInit(): void {
        this.fulfillerService.list().subscribe(s => {
            this.fulfillerIds = s.map(s => s.id).filter(fulfillerId => !this.data.usedFulfillerId.includes(fulfillerId))
                .sort((a, b) => a.localeCompare(b));
            this.form.controls['fulfillerId'].valueChanges.subscribe(filter => {
                this.filteredFulfillerIds.next(this.fulfillerIds.filter(x => x.toLowerCase().includes(filter.toLowerCase())));
            });
        });
    }

    valid() {
        if (!this.fulfillerId) {
            return;
        }

        this.dialogRef.close({
            fulfillerId: this.fulfillerId,
        });
    }

    isValueValid(): boolean {
        if (!this.fulfillerId) {
            return false;
        }
        return this.fulfillerIds.includes(this.fulfillerId);
    }
}
